/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconExposurePlus1 = createReactComponent("outline", "exposure-plus-1", "IconExposurePlus1", [["path", { "d": "M3 12h6", "key": "svg-0" }], ["path", { "d": "M6 9v6", "key": "svg-1" }], ["path", { "d": "M18 19v-14l-4 4", "key": "svg-2" }]]);

export { IconExposurePlus1 as default };
//# sourceMappingURL=IconExposurePlus1.mjs.map
